import Swiper from 'swiper/bundle';
import 'swiper/css';

export function sliderScripts() {
    document.addEventListener( 'DOMContentLoaded', function () {
        const blocks = document.querySelectorAll('.blockSliderAndText .mySwiper');
        blocks.forEach((slide) =>{
            let freeMode =  false;
            let loop =  false;
            let slidesDesktop =  3;
            let slidesTablet =  2.4;
            let slidesMobile =  1.1;
            let spaceBetween = 20;

            let swiper = new Swiper(slide, {
                direction: 'horizontal',
                loop: loop,
                freeMode: freeMode,
                spaceBetween: 8,
                slidesPerView: 1.1,
                breakpoints: {
                    1024: {
                        slidesPerView: 2.4,
                        spaceBetween: 24,
                    },
                    1440: {
                        slidesPerView: 3,
                        spaceBetween: 24
                    },
                    1920: {
                        slidesPerView: 3.2,
                        spaceBetween: 24
                    }
                },
                scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true
                }
            });
        })
    })
}